import { ApiModels } from '@mona/api';
import { ExternalResource } from '@mona/models';

/**
 * Transforms api ExternalResource
 *
 * @param apiExternalResource ApiModels.externalResource
 */
export const transformApiExternalResource = (apiExternalResource: ApiModels.ExternalLink): ExternalResource => {
    return ApiModels.ExternalLink.DTO.toModel(apiExternalResource);
};
/**
 * Transform api ExternalResources
 *
 * @param apeExternalResources ApiModels.ExternalResource[]
 */
export const transformApiExternalResources = (apeExternalResources: ApiModels.ExternalLink[]): ExternalResource[] => {
    return apeExternalResources.map(externalResource => transformApiExternalResource(externalResource));
};
